"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSearchBox = exports.FocusPosType = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var clone_1 = tslib_1.__importDefault(require("clone"));
var Tag_1 = require("./Tag");
var TagInput_1 = require("./TagInput");
var with_outside_click_1 = require("../_util/with-outside-click");
var i18n_1 = require("../i18n");
var bubble_1 = require("../bubble");
var modal_1 = require("../modal");
var TagSearchBoxContext_1 = require("./TagSearchBoxContext");
var button_1 = require("../button");
var util_1 = require("../util");
var noop_1 = require("../_util/noop");
var TagSearchBoxHelp_1 = require("./TagSearchBoxHelp");
/**
 * 焦点所在位置类型
 */
var FocusPosType;
(function (FocusPosType) {
    FocusPosType[FocusPosType["INPUT"] = 0] = "INPUT";
    FocusPosType[FocusPosType["INPUT_EDIT"] = 1] = "INPUT_EDIT";
    FocusPosType[FocusPosType["TAG"] = 2] = "TAG";
})(FocusPosType = exports.FocusPosType || (exports.FocusPosType = {}));
var COUNTER = 0;
var ITagSearchBox = /** @class */ (function (_super) {
    tslib_1.__extends(ITagSearchBox, _super);
    function ITagSearchBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: false,
            dialogActive: false,
            curPos: 0,
            curPosType: FocusPosType.INPUT,
            showSelect: true,
            tags: _this.props.defaultValue
                ? _this.props.defaultValue.map(function (item) {
                    item["_key"] = COUNTER++;
                    return item;
                })
                : [],
            lastValue: _this.props.value,
        };
        _this.resetTagsState = function (props, callback) {
            if ("value" in props) {
                var value = props.value.map(function (item) {
                    if (!("_key" in item)) {
                        item["_key"] = COUNTER++;
                    }
                    return item;
                });
                _this.setState({ tags: clone_1.default(value) }, function () {
                    callback && callback();
                });
            }
        };
        _this.open = function () {
            var disabled = _this.props.disabled;
            if (disabled) {
                return;
            }
            var active = _this.state.active;
            var tags = _this.state.tags || [];
            if (!active) {
                _this.setState({ active: true });
                // 展开时不激活 select 显示
                _this.setState({ curPosType: FocusPosType.INPUT, curPos: tags.length });
            }
            else {
                _this.handleTagEvent("click-input", tags.length);
            }
            _this.setState({ showSelect: true });
            setTimeout(function () {
                var _a;
                (_a = _this["tag-" + tags.length]) === null || _a === void 0 ? void 0 : _a.moveToEnd();
            }, 100);
        };
        _this.close = function () {
            // 编辑未完成的取消编辑
            var tags = _this.state.tags.map(function (item, index) {
                var _a;
                if (item["_edit"]) {
                    (_a = _this["tag-" + index]) === null || _a === void 0 ? void 0 : _a.editDone();
                    item["_edit"] = false;
                }
                return item;
            });
            _this.setTags(tags, function () {
                _this.setState({ showSelect: false });
                if (_this.state.active) {
                    _this.setState({ curPos: -1 }, function () {
                        return _this.setState({ active: false }, function () {
                            if (_this["search-box"]) {
                                _this["search-box"].scrollLeft = 0;
                            }
                        });
                    });
                }
            }, false);
        };
        _this.getValue = function (tags) {
            var result = [];
            tags.forEach(function (item) {
                var values = item.values, _a = item.attr, attr = _a === void 0 ? null : _a;
                if (values.length > 0) {
                    result.push({ attr: attr, values: values, _key: item["_key"], _edit: item["_edit"] });
                }
            });
            return result;
        };
        _this.notify = function (tags) {
            var _a = _this.props.onChange, onChange = _a === void 0 ? noop_1.noop : _a;
            onChange(_this.getValue(tags));
        };
        /**
         * 点击清除按钮触发事件
         */
        _this.handleClear = function (e) {
            var _a;
            e.stopPropagation();
            var _b = _this.props.onClearButtonClick, onClearButtonClick = _b === void 0 ? noop_1.noop : _b;
            onClearButtonClick(e);
            var tags = _this.state.tags;
            var nextTags = tags.filter(function (i) { return i.attr && i.attr.removeable === false; });
            var index = "tag-" + nextTags.length;
            if (tags.length <= 0) {
                (_a = _this[index]) === null || _a === void 0 ? void 0 : _a.setInputValue("");
                return;
            }
            _this.setTags(nextTags, function () {
                return setTimeout(function () {
                    var _a, _b;
                    (_a = _this[index]) === null || _a === void 0 ? void 0 : _a.setInputValue("");
                    (_b = _this[index]) === null || _b === void 0 ? void 0 : _b.focusInput();
                }, 0);
            });
            _this.setState({ curPos: 0, curPosType: FocusPosType.INPUT });
            // 刷新下拉列表位置
            var input = _this["tag-" + tags.length];
            if (input) {
                input === null || input === void 0 ? void 0 : input.scheduleUpdate();
            }
        };
        /**
         * 点击帮助触发事件
         */
        _this.handleHelp = function (e) {
            e.stopPropagation();
            var _a = _this.props.onHelpButtonClick, onHelpButtonClick = _a === void 0 ? noop_1.noop : _a;
            if (onHelpButtonClick(e) === false) {
                return;
            }
            _this.setState({ dialogActive: true });
        };
        /**
         * 点击搜索触发事件
         */
        _this.handleSearch = function (e) {
            if (!_this.state.active) {
                // 如果监听了按钮点击，此时点击按钮不激活搜索框
                if ("onSearchButtonClick" in _this.props) {
                    e.stopPropagation();
                    _this.props.onSearchButtonClick(e, _this.getValue(_this.state.tags));
                }
                return;
            }
            e.stopPropagation();
            // 输入值生成标签操作会异步改变 tags
            // 此处保证 tags 状态变化完成后再进行回调
            setTimeout(function () {
                var _a = _this.props.onSearchButtonClick, onSearchButtonClick = _a === void 0 ? noop_1.noop : _a;
                onSearchButtonClick(e, _this.getValue(_this.state.tags));
            }, 100);
            var _a = _this.state, curPos = _a.curPos, curPosType = _a.curPosType, tags = _a.tags;
            var flag = false;
            var input = _this["tag-" + tags.length];
            if (input && input.addTagByInputValue) {
                if (input.addTagByInputValue()) {
                    flag = true;
                }
            }
            for (var i = 0; i < tags.length; ++i) {
                if (!_this["tag-" + i] || !_this["tag-" + i].addTagByEditInputValue)
                    return;
                if (tags[i]["_edit"] && _this["tag-" + i].addTagByEditInputValue())
                    flag = true;
            }
            if (flag)
                return;
            _this.notify(_this.state.tags);
            input.focusInput();
        };
        /**
         *  处理Tag相关事件
         */
        _this.handleTagEvent = function (type, index, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var active, tags, _a, canDelteTag, attr, pos_1;
            var _this = this;
            var _b, _c, _d, _e;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        active = this.state.active;
                        tags = clone_1.default(this.state.tags);
                        _a = type;
                        switch (_a) {
                            case "add": return [3 /*break*/, 1];
                            case "edit": return [3 /*break*/, 2];
                            case "edit-cancel": return [3 /*break*/, 3];
                            case "editing": return [3 /*break*/, 4];
                            case "del": return [3 /*break*/, 5];
                            case "click": return [3 /*break*/, 7];
                            case "click-input": return [3 /*break*/, 8];
                        }
                        return [3 /*break*/, 9];
                    case 1:
                        payload["_key"] = COUNTER++;
                        tags.splice(++index, 0, payload);
                        this.setTags(tags, function () {
                            var _a;
                            (_a = _this["tag-" + index]) === null || _a === void 0 ? void 0 : _a.focusInput();
                        });
                        this.setState({ showSelect: false });
                        return [3 /*break*/, 9];
                    case 2:
                        (_b = this["tag-" + index]) === null || _b === void 0 ? void 0 : _b.editDone();
                        tags[index].attr = payload.attr;
                        tags[index].values = payload.values;
                        tags[index]["_edit"] = false;
                        this.setTags(tags);
                        index++;
                        this.setState({ showSelect: false, curPosType: FocusPosType.INPUT });
                        return [3 /*break*/, 9];
                    case 3:
                        (_c = this["tag-" + index]) === null || _c === void 0 ? void 0 : _c.editDone();
                        this.setTags(tags, function () { return null; }, false);
                        this.setState({ showSelect: false, curPosType: FocusPosType.INPUT });
                        return [3 /*break*/, 9];
                    case 4:
                        if ("attr" in payload && tags[index])
                            tags[index].attr = payload.attr;
                        if ("values" in payload && tags[index])
                            tags[index].values = payload.values;
                        this.setTags(tags, null, false);
                        return [3 /*break*/, 9];
                    case 5:
                        if (payload === "keyboard")
                            index--;
                        if (!tags[index])
                            return [3 /*break*/, 9];
                        return [4 /*yield*/, ((_e = (_d = this.props).onDeleteTag) === null || _e === void 0 ? void 0 : _e.call(_d, tags[index]))];
                    case 6:
                        canDelteTag = _f.sent();
                        if (this.props.onDeleteTag && !Boolean(canDelteTag))
                            return [3 /*break*/, 9];
                        attr = tags[index].attr;
                        if (attr && (attr === null || attr === void 0 ? void 0 : attr.removeable) === false) {
                            return [3 /*break*/, 9];
                        }
                        tags.splice(index, 1);
                        this.setTags(tags, function () {
                            _this.setState({ curPosType: FocusPosType.INPUT });
                        });
                        if (payload !== "edit") {
                            this.setState({ showSelect: false });
                        }
                        return [3 /*break*/, 9];
                    case 7:
                        if (!active) {
                            this.open();
                            return [2 /*return*/];
                        }
                        pos_1 = payload;
                        tags[index]["_edit"] = true;
                        this.setTags(tags, function () {
                            _this.setState({ showSelect: true }, function () {
                                var _a;
                                (_a = _this["tag-" + index]) === null || _a === void 0 ? void 0 : _a.edit(pos_1);
                            });
                        }, false);
                        this.setState({ curPosType: FocusPosType.INPUT_EDIT });
                        return [3 /*break*/, 9];
                    case 8:
                        if (payload === "edit") {
                            this.setState({ curPosType: FocusPosType.INPUT_EDIT });
                        }
                        else {
                            this.setState({ curPosType: FocusPosType.INPUT });
                        }
                        if (!active) {
                            this.setState({ active: true });
                        }
                        this.setState({ showSelect: true });
                        return [3 /*break*/, 9];
                    case 9:
                        this.setState({ curPos: index });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ITagSearchBox.prototype.componentDidMount = function () {
        this.resetTagsState(this.props);
    };
    ITagSearchBox.getDerivedStateFromProps = function (props, state) {
        if ("value" in props && props.value !== state.lastValue) {
            var value = props.value.map(function (item) {
                if (!("_key" in item)) {
                    item["_key"] = COUNTER++;
                }
                return item;
            });
            return { tags: clone_1.default(value), lastValue: props.value };
        }
        return null;
    };
    // Tags 发生变动
    ITagSearchBox.prototype.setTags = function (tags, callback, notify) {
        var _this = this;
        if (notify === void 0) { notify = true; }
        var cb = function () {
            notify && _this.notify(tags);
            callback && callback();
        };
        // 受控模式
        if (notify && this.props.value) {
            this.resetTagsState(this.props, cb);
        }
        else {
            this.setState({ tags: tags }, cb);
        }
    };
    ITagSearchBox.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.state, active = _b.active, tags = _b.tags, curPos = _b.curPos, curPosType = _b.curPosType, dialogActive = _b.dialogActive, showSelect = _b.showSelect;
        var _c = this.props, t = _c.t, classPrefix = _c.config.classPrefix, className = _c.className, _d = _c.style, style = _d === void 0 ? {} : _d, _e = _c.minWidth, minWidth = _e === void 0 ? 210 : _e, _f = _c.attributes, attributes = _f === void 0 ? [] : _f, hideHelp = _c.hideHelp, _g = _c.tips, tips = _g === void 0 ? t.tagSearchBoxTips : _g, _h = _c.attributesSelectTips, attributesSelectTips = _h === void 0 ? t.tagSearchBoxSelectTitle : _h, disableAttributesFilter = _c.disableAttributesFilter, disabled = _c.disabled, forwardRef = _c.forwardRef;
        // 用于计算 focused 及 isFocused, 判断是否显示选择组件
        // (直接使用 Input 组件内部 onBlur 判断会使得 click 时组件消失)
        var focusedInputIndex = -1;
        if (curPosType === FocusPosType.INPUT ||
            curPosType === FocusPosType.INPUT_EDIT) {
            focusedInputIndex = curPos;
        }
        var tagList = tags.map(function (item, index) {
            // 补全 attr 属性
            attributes.forEach(function (attrItem) {
                if (item.attr && attrItem.key && attrItem.key == item.attr.key) {
                    item.attr = Object.assign({}, item.attr, attrItem);
                }
            });
            var selectedAttrKeys = [];
            tags.forEach(function (tag) {
                if (tag.attr &&
                    item.attr &&
                    item["_edit"] &&
                    item.attr.key === tag.attr.key) {
                    return null;
                }
                if (tag.attr && tag.attr.key && !tag.attr.reusable) {
                    selectedAttrKeys.push(tag.attr.key);
                }
            });
            var useableAttributes = attributes.filter(function (item) { return selectedAttrKeys.indexOf(item.key) < 0; });
            return (react_1.default.createElement(Tag_1.Tag, { ref: function (tag) { return (_this["tag-" + index] = tag); }, active: active, key: item["_key"], attributes: useableAttributes, attr: item.attr, values: item.values, maxWidth: _this["search-wrap"] ? _this["search-wrap"].clientWidth : null, focused: focusedInputIndex === index && showSelect ? curPosType : null, dispatchTagEvent: function (type, payload) {
                    return _this.handleTagEvent(type, index, payload);
                } }));
        });
        var selectedAttrKeys = tags
            .map(function (item) { return (item.attr && !item.attr.reusable ? item.attr.key : null); })
            .filter(function (item) { return !!item; });
        var useableAttributes = attributes.filter(function (item) { return selectedAttrKeys.indexOf(item.key) < 0; });
        tagList.push(react_1.default.createElement(TagInput_1.TagInput, { key: "__input__", ref: function (input) { return (_this["tag-" + tags.length] = input); }, active: active, maxWidth: this["search-wrap"] ? this["search-wrap"].clientWidth : null, attributes: useableAttributes, isFocused: focusedInputIndex === tags.length && showSelect, dispatchTagEvent: function (type, payload) {
                return _this.handleTagEvent(type, tags.length, payload);
            } }));
        return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-search " + classPrefix + "-search--tags", className, {
                "is-active": !disabled && active,
                "is-disabled": disabled,
            }), ref: util_1.mergeRefs(function (div) { return (_this["search-wrap"] = div); }, forwardRef), style: active ? style : tslib_1.__assign(tslib_1.__assign({}, style), { width: minWidth }) },
            react_1.default.createElement("div", { className: classPrefix + "-search__inner", onClick: this.open, ref: function (div) { return (_this["search-box"] = div); }, style: disabled ? undefined : { cursor: "text" } },
                react_1.default.createElement("div", { className: classPrefix + "-tag-group" },
                    react_1.default.createElement(TagSearchBoxContext_1.TagSearchBoxContext.Provider, { value: {
                            attributesSelectTips: attributesSelectTips,
                            disableAttributesFilter: disableAttributesFilter,
                            close: this.close,
                        } }, tagList)),
                react_1.default.createElement("div", { className: classPrefix + "-text-weak " + classPrefix + "-search__tips", style: { position: "relative", userSelect: "none" } }, tips),
                !!active && tags.length > 0 && (react_1.default.createElement(bubble_1.Bubble, { content: t.cleanText },
                    react_1.default.createElement(button_1.Button, { htmlType: "button", type: "icon", icon: "dismiss", className: classnames_1.default((_a = {},
                            _a[classPrefix + "-btn--dismiss"] = !hideHelp,
                            _a[classPrefix + "-btn--info"] = !!hideHelp,
                            _a)), onClick: this.handleClear }))),
                !!active && !hideHelp && (react_1.default.createElement(bubble_1.Bubble, { content: t.helpText },
                    react_1.default.createElement(button_1.Button, { htmlType: "button", type: "icon", icon: "info", className: classPrefix + "-btn--info", onClick: this.handleHelp }))),
                react_1.default.createElement(bubble_1.Bubble, { content: active ? t.searchText : null },
                    react_1.default.createElement(button_1.Button, { htmlType: "button", type: "icon", icon: "search", className: classPrefix + "-btn--search", disabled: disabled, onClick: this.handleSearch }))),
            react_1.default.createElement(modal_1.Modal, { visible: dialogActive, size: 988, caption: t.helpText, onClose: function () { return _this.setState({ dialogActive: false }); }, className: "ignore-outside-click" },
                react_1.default.createElement(modal_1.Modal.Body, null,
                    react_1.default.createElement(TagSearchBoxHelp_1.TagSearchBoxHelp, null)))));
    };
    ITagSearchBox = tslib_1.__decorate([
        with_outside_click_1.withOutsideClick("close")
    ], ITagSearchBox);
    return ITagSearchBox;
}(react_1.default.Component));
exports.TagSearchBox = react_1.default.forwardRef(function (props, ref) {
    var C = react_1.useMemo(function () { return util_1.withConfig(i18n_1.withTranslation(ITagSearchBox)); }, []);
    return react_1.default.createElement(C, tslib_1.__assign({}, props, { forwardRef: ref }));
});
exports.TagSearchBox.displayName = "TagSearchBox";
//# sourceMappingURL=TagSearchBox.js.map